module.exports = __webpack_public_path__ + "static/media/sales_home.8613e7ba.png";